import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
// import Crop image
import Cropper from "react-easy-crop";
import getCroppedImg from "./getCropImage";

import { Col, Row } from "react-bootstrap";

//Import module Modal
import Modal from "react-bootstrap/Modal";

function ModalCrop(props) {
  // const user = JSON.parse(sessionStorage.getItem("user"));
  // Crop image Functions
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [croppedImage, setCroppedImage] = useState(null);
  const onCropComplete = useCallback(async (croppedArea, croppedAreaPixels) => {
    console.log(croppedArea);
    console.log(croppedAreaPixels);
    setCroppedAreaPixels(croppedAreaPixels);
    // showCroppedImage();
  }, []);
  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(props.image, croppedAreaPixels);
      console.log(croppedImage);
      // setCroppedImage(croppedImage);
      props.setCrop({ file: croppedImage.file, preview: croppedImage.preview });
      props.hidden(false);
    } catch (e) {
      console.error(e);
    }
  };
  const handleClose = () => {
    showCroppedImage();
  };

  const handleSubmit = () => {
    showCroppedImage();
  };
  useEffect(() => {
    setZoom(1);
  }, [props.image]);

  return (
    <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col
            style={{
              textAlign: "-webkit-center",
            }}
          >
            <Cropper
              image={props.image}
              crop={crop}
              zoom={zoom}
              aspect={4 / 4}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              style={{
                containerStyle: {
                  position: "relative",
                  height: "200px",
                  width: "200px",
                },
              }}
            />
          </Col>
          {/* <Col>
            <img
              src={croppedImage ? croppedImage.preview : null}
              alt="No Image"
              width="150"
              height="150"
            />
          </Col> */}
        </Row>
        {/* <Row>
          <Col>
            <Button onClick={showCroppedImage}>Crop</Button>
          </Col>
        </Row> */}
      </Modal.Body>
      <Modal.Footer>
        {/* <button className="btn btn-warning" onClick={handleClose}>
          ยกเลิก
        </button> */}
        <button
          className="btn btn-primary"
          type="submit"
          onClick={handleSubmit}
        >
          ตกลง
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCrop;

ModalCrop.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  image: PropTypes.string,
  setCrop: PropTypes.func,
};
